/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateContainerCommand } from '../../models/update-container-command';
import { UpdateContainerCommandResult } from '../../models/update-container-command-result';

export interface ApiContainersUpdateContainerPatch$Params {
      body?: UpdateContainerCommand
}

export function apiContainersUpdateContainerPatch(http: HttpClient, rootUrl: string, params?: ApiContainersUpdateContainerPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateContainerCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiContainersUpdateContainerPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateContainerCommandResult>;
    })
  );
}

apiContainersUpdateContainerPatch.PATH = '/api/Containers/UpdateContainer';
